<section class="mt-16">
  <div class="min-h-screen bg-[#f7f7f8] py-10 px-4">

    <div class="max-w-4xl mx-auto bg-white rounded-[28px] shadow-sm border border-gray-100 overflow-hidden">

      <!-- Content -->
      <div class="px-6 sm:px-14 py-12">

        <!-- Top Icon -->
        <div class="flex justify-center">
          <div class="w-16 h-16 rounded-full border border-violet-200 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-8 h-8 text-violet-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >

              <!-- Face Circle -->
              <circle
                cx="12"
                cy="12"
                r="9"
                stroke-width="1.8"
              />

              <!-- Left Eye -->
              <circle
                cx="9"
                cy="10"
                r="0.8"
                fill="currentColor"
                stroke="none"
              />

              <!-- Right Eye -->
              <circle
                cx="15"
                cy="10"
                r="0.8"
                fill="currentColor"
                stroke="none"
              />

              <!-- Sad Mouth -->
              <path
                d="M8.5 16C9.5 14.5 11 14 12 14C13 14 14.5 14.5 15.5 16"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />

              <!-- Left Eyebrow -->
              <path
                d="M7.8 7.8C8.5 7.2 9.3 7.1 10.2 7.5"
                stroke-width="1.8"
                stroke-linecap="round"
              />

              <!-- Right Eyebrow -->
              <path
                d="M13.8 7.5C14.7 7.1 15.5 7.2 16.2 7.8"
                stroke-width="1.8"
                stroke-linecap="round"
              />

            </svg>
          </div>
        </div>

        <!-- Heading -->
        <div class="text-center mt-6">
          <h1 class="text-3xl sm:text-4xl font-semibold text-gray-900 tracking-tight">
            We’re Sorry to See You Go
          </h1>

          <p class="mt-4 text-gray-500 text-base leading-7 max-w-2xl mx-auto">
            Before you opt-out, we'd love to understand what made you decide to leave.
            Your feedback helps us improve the experience.
          </p>

          <div class="w-12 h-[2px] bg-violet-500 mx-auto mt-6 rounded-full"></div>
        </div>

        <!-- Form -->
        <form
          [formGroup]="unsubscribeForm"
          (ngSubmit)="submitForm()"
          class="mt-14 space-y-10"
        >

          <!-- Email -->
          <div>
            <label class="block text-sm font-medium text-gray-800 mb-3">
              Email Address
            </label>

            <input
              type="email"
              formControlName="email"
              placeholder="Enter your email"
              class="w-full h-14 rounded-2xl border border-gray-200 px-5 text-gray-800 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent transition"
              readonly
            />
          </div>

          <!-- Reasons -->
          <div>

            <h2 class="text-xl font-semibold text-gray-900">
              Why are you opting out?
            </h2>

            <p class="text-sm text-gray-500 mt-1">
              Select all that apply
            </p>

            <div class="mt-8 divide-y divide-gray-100 border-t border-b border-gray-100">

              <!-- Item -->
              <label class="flex items-center gap-4 py-5 cursor-pointer group">

                <input
                  type="checkbox"
                  formControlName="alreadyPurchased"
                  class="w-5 h-5 rounded border-gray-300 text-violet-600 focus:ring-violet-500"
                />

                <span class="text-gray-700 group-hover:text-gray-900 transition">
                  Already purchased a property
                </span>
              </label>

              <label class="flex items-center gap-4 py-5 cursor-pointer group">

                <input
                  type="checkbox"
                  formControlName="noLongerLooking"
                  class="w-5 h-5 rounded border-gray-300 text-violet-600 focus:ring-violet-500"
                />

                <span class="text-gray-700 group-hover:text-gray-900 transition">
                  ⁠No longer looking to buy/rent
                </span>
              </label>

              <label class="flex items-center gap-4 py-5 cursor-pointer group">

                <input
                  type="checkbox"
                  formControlName="notRelevant"
                  class="w-5 h-5 rounded border-gray-300 text-violet-600 focus:ring-violet-500"
                />

                <span class="text-gray-700 group-hover:text-gray-900 transition">
                   ⁠Listings are not relevant to me
                </span>
              </label>

              <label class="flex items-center gap-4 py-5 cursor-pointer group">

                <input
                  type="checkbox"
                  formControlName="technicalIssues"
                  class="w-5 h-5 rounded border-gray-300 text-violet-600 focus:ring-violet-500"
                />

                <span class="text-gray-700 group-hover:text-gray-900 transition">
                  Technical issues
                </span>
              </label>

              <label class="flex items-center gap-4 py-5 cursor-pointer group">

                <input
                  type="checkbox"
                  formControlName="switchingService"
                  class="w-5 h-5 rounded border-gray-300 text-violet-600 focus:ring-violet-500"
                />

                <span class="text-gray-700 group-hover:text-gray-900 transition">
                  Switching to another service
                </span>
              </label>

              <label class="flex items-center gap-4 py-5 cursor-pointer group">

                <input
                  type="checkbox"
                  formControlName="manyNotifications"
                  class="w-5 h-5 rounded border-gray-300 text-violet-600 focus:ring-violet-500"
                />

                <span class="text-gray-700 group-hover:text-gray-900 transition">
                  ⁠Too many notifications
                </span>
              </label>

            </div>
          </div>

          <!-- Feedback -->
          <div>

            <label class="block text-sm font-medium text-gray-800 mb-3">
              Additional Feedback
            </label>

            <textarea
              rows="5"
              formControlName="feedback"
              placeholder="Tell us more about your experience..."
              class="w-full rounded-2xl border border-gray-200 px-5 py-4 text-gray-800 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent resize-none transition"
            ></textarea>

            <p class="text-sm text-gray-400 mt-3">
              Your feedback is optional and helps us improve.
            </p>
          </div>

          <!-- Soft Retention Box -->
          <div class="rounded-2xl bg-violet-50 border border-violet-100 px-6 py-5 flex items-start gap-4">

            <div class="mt-1 text-violet-600">
              ♡
            </div>

            <div>
              <h3 class="font-medium text-gray-900">
                We'd love to have you back
              </h3>

              <p class="text-sm text-gray-500 mt-1">
                If you change your mind, your account will always be here.
              </p>
            </div>
          </div>

          <!-- Actions -->
          <div class="flex flex-col sm:flex-row justify-end gap-4 pt-2">

            <button
              type="button"
              class="h-12 px-6 rounded-xl border border-gray-200 text-gray-700 hover:bg-gray-50 transition"
            >
              Cancel
            </button>

            <button
              type="submit" [disabled]="loading"
              class="h-12 px-7 rounded-xl bg-violet-600 hover:bg-violet-700 text-white font-medium transition shadow-sm"
            > {{ loading ? 'Processing...' : 'Confirm Opting Out' }}
            </button>

          </div>

          <!-- Footer -->
          <div class="pt-2 text-center text-sm text-gray-400">
            🔒 Your data is safe with us.
          </div>

        </form>
      </div>
    </div>
  </div>
</section>